import React, { useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { globalHistory } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';

import AnnouncementBar from './AnnouncementBar';
import MainNavigation from './MainNavigation';
import NoMenuNav from './NoMenuNav';

const Container = styled.div`
	position: ${({ noStickyHeader }) => (noStickyHeader ? 'absolute' : 'fixed')};
	z-index: 10;
	width: 100%;
`;

const FixedNavigation = ({
	darkMode,
	noLinkLogo,
	simpleCta,
	setHeaderHeight,
	noMenu,
	noStickyHeader,
}) => {
	const announcementData = useStaticQuery(graphql`
		query {
			contentfulAnnouncementBar(
				contentful_id: { eq: "5FQFLBXVrDmYi2CcoOloQ" }
			) {
				isActive
				staticDisplay
				currentAnnouncement {
					announcementButtonLink
					announcementButtonText
					announcementMainText
				}
			}
		}
	`);

	const [announcementOpen, setAnnouncementOpen] = useState(false);
	const { isActive, staticDisplay, currentAnnouncement } =
		announcementData.contentfulAnnouncementBar;
	const { announcementButtonLink } = currentAnnouncement;
	const theme = useTheme();

	useEffect(() => {
		const isAnnouncementPage = location.href === announcementButtonLink;
		const isHelpPage = location.href.includes('/help');
		const hasClosed = sessionStorage.getItem('close_announcement') === 'true';

		if (!isAnnouncementPage && !isHelpPage && !hasClosed && isActive) {
			setAnnouncementOpen(true);
		}

		const unlisten = globalHistory.listen(({ action }) => {
			if (action === 'PUSH' && !staticDisplay) {
				sessionStorage.setItem('close_announcement', 'true');
			}
		});

		return () => unlisten(); // clean up
	}, [announcementButtonLink, staticDisplay]);

	useEffect(() => {
		if (announcementOpen) {
			setHeaderHeight(
				theme.fixedHeights.announcementBar + theme.fixedHeights.navBar
			);
		} else {
			setHeaderHeight(theme.fixedHeights.navBar);
		}
	}, [announcementOpen]);

	return (
		<Container noStickyHeader={noStickyHeader}>
			{announcementOpen && (
				<AnnouncementBar
					content={announcementData.contentfulAnnouncementBar}
					setAnnouncementOpen={setAnnouncementOpen}
					open={announcementOpen}
				/>
			)}
			{noMenu ? (
				<NoMenuNav noLinkLogo={noLinkLogo} simpleCta={simpleCta} />
			) : (
				<MainNavigation darkMode={darkMode} />
			)}
		</Container>
	);
};

export default FixedNavigation;
